module.exports = __webpack_public_path__ + "img/woman.69eaefb4.png";